<template>
  <div class="box">
    <el-form :inline="true" :model="formData" ref="topForm" label-width="80px">
      <el-form-item prop="name" label="姓名">
        <el-input size="small" v-model="formData.name" placeholder="姓名" style="width:150px"></el-input>
      </el-form-item>

      <el-form-item prop="username" label="账号">
        <el-input size="small" v-model="formData.username" placeholder="账号" style="width:150px"></el-input>
      </el-form-item>
      
      <el-form-item>
        <el-button size="small" type="primary" @click="onSubmit" icon="el-icon-search">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="resetForm('topForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // dateFrame:[],
      formData: {
        name: '', // 姓名
        username: '', // 账号
      },
    }
  },
  methods: {
    onSubmit() {
      let temData = {};
      for (let key in this.formData) {
        if (this.formData[key] !== "" && this.formData[key] !== null) {
          temData[key] = this.formData[key];
        }
      }
      
      this.$emit("submit", temData);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      let temData = {};
      for (let key in this.formData) {
        if (this.formData[key] !== "" && this.formData[key] !== null) {
          temData[key] = this.formData[key];
        }
      }
      this.$emit("submit", temData);
    },
  }
}
</script>
<style>
</style>